import React from "react";
import PropTypes from "prop-types";

function limitString(str, limit) {
  return str.substring(0, limit);
}

class Field extends React.Component {
  static propTypes = {
    charLimit: PropTypes.number,
    autoFocus: PropTypes.bool,
    onDone: PropTypes.func,
    name: PropTypes.string,
  };

  componentDidMount() {
    this.ref?.focus();
  }
  _handleTextChange(e) {
    this.inputValue = this.props.charLimit > 0 ? limitString(e.target.value, this.props.charLimit) : e.target.value;
  }

  render() {
    const { autoFocus, onDone, name } = this.props;

    // auto focus
    const ref = autoFocus
      ? (ref) => {
          this.ref = ref;
        }
      : null;
    return (
      <input
        onChange={this._handleTextChange.bind(this)}
        ref={ref}
        defaultValue={name}
        type="text"
        onBlur={() => {
          onDone(this.inputValue ?? name);
        }}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            onDone(this.inputValue ?? name);
          }
        }}
        maxLength={this.props.charLimit}
      />
    );
  }
}
export default class EditableContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
    };
  }

  static propTypes = {
    charLimit: PropTypes.number,
    autoFocus: PropTypes.bool,
    onDone: PropTypes.func,
    name: PropTypes.string,
    updateName: PropTypes.func,
    children: PropTypes.node,
    tag: PropTypes.string,
    className: PropTypes.string,
    currentIndex: PropTypes.number,
  };

  componentWillUnmount() {
    // cancel click callback
    if (this.timeout) clearTimeout(this.timeout);
  }

  handleClick() {
    this.setState({
      edit: true,
    });
  }

  handleDone(inputValue) {
    this.setState({
      edit: false,
    });

    this.props.updateName(inputValue, this.props.currentIndex);
  }

  render() {
    const { children, ...rest } = this.props;
    const { edit } = this.state;
    if (edit) {
      return <Field autoFocus {...rest} onDone={this.handleDone.bind(this)} />;
    }
    return React.createElement(
      this.props.tag ?? "div",
      {
        className: this.props.className,
        onClick: this.handleClick.bind(this),
      },
      children,
    );
  }
}
